import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";
import {FormattedMessage} from "react-intl";

import './GeneralAlertPopUp.style.scss';
const GeneralAlertPopUp = ({id, open, onClose, onCancel, onOk, options}) => {

    return (
        <Dialog open={open} onClose={onClose} className="GeneralAlertPopUp">
            <DialogContent className="GeneralAlertContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    {options.title}
                </Typography>
                <Typography className="details">
                    {options.details}
                </Typography>
                <div className={'actionButton'}>
                    <Button className="okButton" onClick={() => {
                        onClose();
                    }}>
                        <FormattedMessage id={'popUp.AccountDetailsChanged.ok'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default GeneralAlertPopUp;
